import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTime(date: Date | string): string {
  const messageDate = new Date(date);
  const now = new Date();
  const diff = now.getTime() - messageDate.getTime();
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  // Today
  if (days === 0) {
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m`;
    if (hours < 24) {
      return messageDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    }
  }

  // Yesterday
  if (days === 1) return 'Yesterday';

  // This week
  if (days < 7) {
    return messageDate.toLocaleDateString('en-US', { weekday: 'short' });
  }

  // Older
  return messageDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}

export function formatMessageTime(date: Date | string): string {
  const messageDate = new Date(date);
  return messageDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function getInitials(name: string): string {
  if (!name) return '?';
  
  // Remove extra spaces and get the clean name
  const cleanName = name.trim();
  
  // Take first two characters of the name (Telegram style)
  // For single word names, take first 2 letters
  // For multi-word names, take first letter of first two words
  const words = cleanName.split(' ').filter(word => word.length > 0);
  
  if (words.length === 1) {
    // Single word - take first 2 characters
    return cleanName.substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first letter of first two words
    return words.slice(0, 2).map(word => word[0]).join('').toUpperCase();
  }
}
